"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFullscreenIcon = void 0;
var createFullscreenIcon = function createFullscreenIcon() {
  var fullscreenIcon = document.createElement('div');
  fullscreenIcon.className = 'cloudimage-360-fullscreen-icon';
  return fullscreenIcon;
};
exports.createFullscreenIcon = createFullscreenIcon;